import React from 'react';
import PropTypes from 'prop-types';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { IconButton } from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
// import SettingsIcon from '@material-ui/icons/Settings';

const MenuComponent = ({ categoryInfo, onDelete, setShowEditCategory, setCategoryEdit }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDelete = () => {
    setAnchorEl(null);
    if (typeof onDelete === 'function') onDelete();
  };
  const handleEdit = () => {
    setAnchorEl(null);
    setShowEditCategory(true);
    setCategoryEdit(categoryInfo);
  };

  return (
    <>
      <IconButton aria-label="delete" onClick={handleClick}>
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={handleEdit}>Edit</MenuItem>
        <MenuItem onClick={handleDelete}>Delete</MenuItem>
      </Menu>
    </>
  );
};

MenuComponent.propTypes = {
  onDelete: PropTypes.func,
  setShowEditCategory: PropTypes.func,
  setCategoryEdit: PropTypes.func,
  categoryInfo: PropTypes.object
};

export default MenuComponent;
